export function mapProducts(products) {
    if (!products || !Array.isArray(products)) {
        return [];
    }
    return products.map((product) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const price = parseFloat(((_b = (_a = product.variants[0]) === null || _a === void 0 ? void 0 : _a.price) === null || _b === void 0 ? void 0 : _b.toString()) || ((_c = product.price_min) === null || _c === void 0 ? void 0 : _c.toString()) || '0');
        const compareAtPrice = parseFloat(((_e = (_d = product.variants[0]) === null || _d === void 0 ? void 0 : _d.compare_at_price) === null || _e === void 0 ? void 0 : _e.toString()) || ((_f = product.compare_at_price_min) === null || _f === void 0 ? void 0 : _f.toString()) || '0');
        const data = {
            id: String(product.id),
            title: product.title,
            handle: product.handle,
            brand: product.vendor,
            color: '',
            size: [''],
            price: {
                regular: price,
                sale: compareAtPrice > price ? compareAtPrice : undefined,
                special: undefined,
            },
            image: {
                url: ((_g = product.images_info[0]) === null || _g === void 0 ? void 0 : _g.src) || '',
                alt: ((_h = product.images_info[0]) === null || _h === void 0 ? void 0 : _h.alt) || `${product.title}-image`,
            },
            images: product.images_info.map((image, index) => ({
                url: image.src,
                alt: image.alt
                    ? `${image.alt}-${index}`
                    : `${product.title}-image-${index}`,
            })),
            availability: product.available
                ? 'in_stock'
                : 'out_of_stock',
            first_variant_id: String(((_j = product.variants[0]) === null || _j === void 0 ? void 0 : _j.id) || product.id),
            description: product.body_html,
            metafields: product.metafields || [],
            productUrl: product.handle,
            vendor: product.vendor || '',
            review_count: product.review_count || 0,
            review_ratings: product.review_ratings || 0,
            options_with_values: ((_k = product.options_with_values) === null || _k === void 0 ? void 0 : _k.map(option => ({
                original_name: option.original_name,
                values: option.values.map(value => ({
                    image: value.image ? String(value.image) : null,
                    title: value.title,
                })),
                name: option.name,
                label: option.label,
                position: option.position,
            }))) || [],
            variants: ((_l = product.variants) === null || _l === void 0 ? void 0 : _l.map(variant => ({
                id: String(variant.id),
                title: variant.title,
                price: parseFloat(variant.price),
                availableForSale: variant.available,
                productUrl: product.handle,
                inventory_quantity: variant.inventory_quantity,
                merged_options: variant.merged_options || [],
            }))) || [],
        };
        return data;
    });
}
export function mapFilters(filter, currentFilters) {
    const filters = [];
    filter.options.map((option) => {
        // Only process filters that have values property and status is 'active'
        if (!option.values || option.status !== 'active') {
            return;
        }
        const filter = {
            id: option.filterOptionId,
            label: option.label,
            type: 'select',
            options: [],
            selectType: option.selectType,
        };
        if (option.displayType === 'list' && Array.isArray(option.values)) {
            if (option.values.length === 0) {
                return;
            }
            const isColorFilter = option.filterType === 'metafield_::bac::colour_group' ||
                option.filterOptionId === 'pf_m_::bac::colour_group';
            filter.type = isColorFilter ? 'color' : 'select';
            filter.options = option.values.map((value) => {
                var _a;
                return {
                    id: String(value.key),
                    label: String(value.key),
                    count: Number(value.doc_count),
                    selected: ((_a = currentFilters === null || currentFilters === void 0 ? void 0 : currentFilters[option.filterOptionId]) === null || _a === void 0 ? void 0 : _a.includes(String(value.key))) || false,
                    value: String(value.key),
                };
            });
        }
        if (option.displayType === 'rating' && Array.isArray(option.values)) {
            if (option.values.length === 0) {
                return;
            }
            filter.type = 'rating';
            const sortedValues = [...option.values].sort((a, b) => {
                const ratingA = parseFloat(String(a.key)) || 0;
                const ratingB = parseFloat(String(b.key)) || 0;
                return ratingB - ratingA;
            });
            filter.options = sortedValues.map((value) => {
                var _a;
                return {
                    id: String(value.key),
                    label: String(value.key),
                    count: Number(value.doc_count),
                    selected: ((_a = currentFilters === null || currentFilters === void 0 ? void 0 : currentFilters[option.filterOptionId]) === null || _a === void 0 ? void 0 : _a.includes(String(value.key))) || false,
                    value: String(value.key),
                    rating: value.from || 0,
                };
            });
        }
        if (option.displayType === 'range') {
            filter.type = 'range';
            const rangeValues = option.values;
            if (option.filterType === 'price' && (currentFilters === null || currentFilters === void 0 ? void 0 : currentFilters.pf_p_price)) {
                const selectedMin = Number(currentFilters.pf_p_price[0].split(':')[0]);
                const selectedMax = Number(currentFilters.pf_p_price[0].split(':')[1]);
                filter.currentMin = selectedMin;
                filter.currentMax = selectedMax;
                filter.options = [
                    {
                        id: `${selectedMin},${selectedMax}`,
                        label: `$${selectedMin} - $${selectedMax}`,
                        selected: true,
                        count: 0,
                    },
                ];
            }
            else {
                filter.currentMin = rangeValues === null || rangeValues === void 0 ? void 0 : rangeValues.min;
                filter.currentMax = rangeValues === null || rangeValues === void 0 ? void 0 : rangeValues.max;
                filter.options = [];
            }
            filter.min = rangeValues === null || rangeValues === void 0 ? void 0 : rangeValues.min;
            filter.max = rangeValues === null || rangeValues === void 0 ? void 0 : rangeValues.max;
        }
        filters.push(filter);
    });
    return filters;
}
export function mapMeta(data, page, pageSize) {
    return {
        totalResults: data.total_product,
        totalPages: Math.ceil(data.total_product / pageSize),
        currentPage: page,
        pageSize,
    };
}
export function mapSorts() {
    return [
        { id: 'relevance', label: 'Relevance' },
        { id: 'price_asc', label: 'Price: Low to High' },
        { id: 'price_desc', label: 'Price: High to Low' },
        { id: 'title_asc', label: 'Name: A to Z' },
        { id: 'title_desc', label: 'Name: Z to A' },
    ];
}
